// extracted by mini-css-extract-plugin
export default {"root":"YXJDt-xo","title":"wyrFkTfm"};